import { keccak256 } from './keccak';
/**
 * derive Address from public key
 * @param pubKey the public key
 */
export function publicKeyToAddress(pubKey) {
    return keccak256(pubKey.slice(1)).slice(12);
}
/**
 * to check if a value presents an address
 * @param v the value to be checked
 */
export function isAddress(v) {
    return typeof v === 'string' && /^0x[0-9a-f]{40}$/i.test(v);
}
/**
 * encode the address to checksum address that is compatible with eip-55
 * @param address input address
 */
export function toChecksumAddress(address) {
    if (!isAddress(address)) {
        throw new Error('invalid address');
    }
    address = address.slice(2).toLowerCase();
    const hash = keccak256(address);
    let checksumAddress = '0x';
    for (let i = 0; i < address.length; i++) {
        // tslint:disable-next-line:no-bitwise
        let byte = hash[i >> 1];
        if (i % 2 === 0) {
            // tslint:disable-next-line:no-bitwise
            byte >>= 4;
        }
        if (byte % 16 >= 8) {
            checksumAddress += address[i].toUpperCase();
        }
        else {
            checksumAddress += address[i];
        }
    }
    return checksumAddress;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkcmVzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jcnkvYWRkcmVzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBQ3BDOzs7R0FHRztBQUNILE1BQU0sNkJBQTZCLE1BQWM7SUFDN0MsT0FBTyxTQUFTLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQTtBQUMvQyxDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxvQkFBb0IsQ0FBTTtJQUM1QixPQUFPLE9BQU8sQ0FBQyxLQUFLLFFBQVEsSUFBSSxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFDL0QsQ0FBQztBQUVEOzs7R0FHRztBQUNILE1BQU0sNEJBQTRCLE9BQWU7SUFDN0MsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsRUFBRTtRQUNyQixNQUFNLElBQUksS0FBSyxDQUFDLGlCQUFpQixDQUFDLENBQUE7S0FDckM7SUFDRCxPQUFPLEdBQUcsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxXQUFXLEVBQUUsQ0FBQTtJQUN4QyxNQUFNLElBQUksR0FBRyxTQUFTLENBQUMsT0FBTyxDQUFDLENBQUE7SUFFL0IsSUFBSSxlQUFlLEdBQUcsSUFBSSxDQUFBO0lBQzFCLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxPQUFPLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1FBQ3JDLHNDQUFzQztRQUN0QyxJQUFJLElBQUksR0FBRyxJQUFJLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFBO1FBQ3ZCLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLEVBQUU7WUFDYixzQ0FBc0M7WUFDdEMsSUFBSSxLQUFLLENBQUMsQ0FBQTtTQUNiO1FBRUQsSUFBSSxJQUFJLEdBQUcsRUFBRSxJQUFJLENBQUMsRUFBRTtZQUNoQixlQUFlLElBQUksT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFBO1NBQzlDO2FBQU07WUFDSCxlQUFlLElBQUksT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFBO1NBQ2hDO0tBQ0o7SUFDRCxPQUFPLGVBQWUsQ0FBQTtBQUMxQixDQUFDIn0=